import React from "react";
import smileyS from "assets/smilyS-v2.png";
import CTA from "components/CTA";

const HomeHero = () => (
	<div id="home-hero" className="md:px-4 px-10 bg-darkblue py-16 md:py-28">
		<div className="flex gap-8 max-md:flex-wrap items-center justify-center md:px-16">
			<div className="flex flex-col items-start justify-end gap-4 md:w-[50%]">
				<div>
					<h1 className="text-white font-bold">
						Losing your marbles sucks<span className="text-primary">.</span>
					</h1>
					<p className="text-white text-[25px] leading-[40px]">
						That doesn&apos;t mean planning for it can&apos;t be DeadEasy.
						Leaving it to loved ones is not cool. So plan for it here, today,
						with our easy, yet legal writing services for both Financial and
						Health needs.
					</p>
				</div>
				<div className="max-md:hidden">
					<CTA title="Get started" color="secondary" />
				</div>
			</div>

			<div className="md:w-[50%] relative md:left-[5%]">
				<div
					className="border-none bg-primary dark:bg-primary font-normal rounded-[40px] p-8 md:p-12 relative max-md:max-w-[350px] max-w-[500px]"
					style={{ boxSizing: "inherit" }}
				>
					<div className="flex justify-center md:left-[50%] md:absolute md:translate-x-[-50%] md:top-[-8%] mb-8">
						<img
							className="w-[60px] h-[60px] relative"
							alt="smiley"
							src={smileyS}
						/>
					</div>
					<h4 className="text-white uppercase font-bold text-center mb-4">
						Our affordable power of attorney writing service costs just
					</h4>
					<div className="flex justify-center items-center gap-4 text-blue">
						<div className="flex flex-col justify-center item-center text-center">
							<h1 className="mb-0">£10</h1>
							<h4 className="normal-case">
								For One Lasting Power of Attorney (LPA)
							</h4>
						</div>
						<div>
							<h3 className="font-bold">OR</h3>
						</div>
						<div className="flex flex-col justify-center item-center text-center">
							<h1 className="mb-0">£15</h1>
							<h4 className="normal-case">
								For both a Financial and a Health LPA.
							</h4>
						</div>
					</div>
					<p className="mt-4">
						You can make unlimited changes for as long as you&apos;re still
						above ground and kicking. <b>Completely free. </b>
						Because let&apos;s be honest — your chosen attorney might have said
						something outrageous at yesterday&apos;s BBQ…Or you simply realised
						you don&apos;t trust them not to “accidentally” switch you off the
						moment you start humming like an old fridge.
					</p>
					<p className="mt-2">
						No awkward conversations required. Just update it and carry on. Your
						future self will thank you. Probably.
					</p>
				</div>
			</div>
		</div>
		<div className="md:hidden flex justify-center mt-24">
			<CTA title="Get started" color="secondary" />
		</div>
	</div>
);

export default HomeHero;
